export default "__VITE_ASSET__CuzP2urE__"